/**
 * **Duplicated verbatim from `apps/web-bidder/src/lib/turnstile.ts`** — keep the two in step.
 * Both apps host unauthenticated, mail-sending or money-moving forms that the Worker guards
 * with the same `turnstile` middleware, so the widget has to exist on both sides. It is app
 * configuration (an env-driven site key), not a presentational primitive, so it does not belong
 * in `packages/ui`.
 */
/**
 * Cloudflare Turnstile config (M8). The site key is env-driven (`VITE_TURNSTILE_SITE_KEY`);
 * when it is unset (dev/CI) the server also skips verification (`TURNSTILE_SECRET` unset), so
 * forms fall back to {@link TURNSTILE_PLACEHOLDER} to satisfy the schema-required field. When a
 * site key is present the real widget (see `components/Turnstile.tsx`) supplies a live token.
 */
export const TURNSTILE_SITE_KEY = (import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '').trim();

/** True when a real Turnstile widget should render (a site key is configured). */
export const turnstileConfigured = TURNSTILE_SITE_KEY.length > 0;

/** Placeholder token used only when Turnstile is not configured (dev/CI). */
export const TURNSTILE_PLACEHOLDER = 'turnstile-todo-m8';

/** The initial token a form should carry: empty (await the widget) when configured, else the placeholder. */
export const initialTurnstileToken = (): string =>
  turnstileConfigured ? '' : TURNSTILE_PLACEHOLDER;
